import styles from "./ScrollToTopBtn.module.css"
import { scrolltopsvg } from "../../assets/svg/svgimages"
import { useState, useEffect } from "react"

const ScrollToTopBtn = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const getScrollY = () => Math.max(
            window.scrollY || 0,
            document.documentElement.scrollTop || 0,
            document.body.scrollTop || 0
        );

        const handleScroll = () => {
            setIsVisible(getScrollY() > 300);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        document.body.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            className={`${styles.btn} ${isVisible ? styles.visible : styles.hidden}`}
            onClick={scrollToTop}
        >
            {scrolltopsvg}
        </button>
    );
};

export default ScrollToTopBtn;